import { render, staticRenderFns } from "./OneCollection.vue?vue&type=template&id=5604cb58"
import script from "./OneCollection.vue?vue&type=script&lang=js"
export * from "./OneCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./OneCollection.vue?vue&type=custom&index=0&blockType=styles&lang=scss"
if (typeof block0 === 'function') block0(component)

export default component.exports